import React from 'react'
import { Route, RouteProps } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { getTokenChanged, getUser } from '../store/common/common.selectors'

const WithAuthRoute = ({ component: Component, path, children }: RouteProps) => {
  const user = useSelector(getUser)
  const tokenChanged = useSelector(getTokenChanged)

  if (!user || !tokenChanged) {
    return null
  }

  return children
    ? <Route path={path}>{children}</Route>
    : <Route component={Component} path={path}/>
}

export default WithAuthRoute
